let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gEj1c")).then(() => parcelRequire('6mrsC'));